import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { Props } from "../views/portfolio-selector-view/Props";
import { PortfolioModel } from "../types/PortfolioModel";
import { AllPortfoliosConstants } from "../constants/AllPortfoliosConstants";

export function PortfolioSelector({
    portfolios,
    selectedPortfolio,
    setSelectedPortfolio,
    setAllPortfolios,
    labelText,
    primaryColour,
    secondaryColour,
    secondaryHoverColour,
    disabled,
}: Props) {
    async function handleSelection(eventArg: SelectChangeEvent<string>) {
        const selectedPortfolioName = eventArg.target.value;

        if (selectedPortfolioName === AllPortfoliosConstants.StorageValue) {
            await setAllPortfolios();
            return;
        }

        const selectedPortfolioModel = portfolios.find(x => x.name === selectedPortfolioName);
        
        if (selectedPortfolioModel === undefined) {
            return;
        }
        
        await setSelectedPortfolio(selectedPortfolioModel);
    }
    
    return (
        <FormControl variant="standard" sx={{ width: 300 }}>
            <InputLabel
                id="portfolios-label"
                sx={{
                    color: secondaryColour,
                    "&.Mui-focused": {
                        color: secondaryHoverColour
                    }
                }}
            >
                <b>{labelText}</b> {getSelectControlLabelExtension(portfolios)}
            </InputLabel>
            <Select
                labelId="portfolios-label"
                value={selectedPortfolio?.id === AllPortfoliosConstants.Id
                    ? AllPortfoliosConstants.StorageValue
                    : selectedPortfolio
                        ? selectedPortfolio?.name.toString()
                        : ' '}
                onChange={handleSelection}
                size="small"
                sx={{
                    color: primaryColour,
                    '&:before': {
                        borderColor: secondaryColour,
                    },
                    '&:after': {
                        borderColor: secondaryHoverColour,
                    },
                    '&:not(.Mui-disabled):hover::before': {
                        borderColor: secondaryColour,
                    },
                    '.MuiSvgIcon-root': {
                        fill: `${secondaryColour} !important`,
                    }
                }}
                disabled={disabled}
            >
                <MenuItem
                    key={AllPortfoliosConstants.StorageValue}
                    value={AllPortfoliosConstants.StorageValue}
                    sx={{
                        borderBottom: "1px solid rgba(0, 0, 0, 0.18)",
                    }}
                >
                    {AllPortfoliosConstants.Name}
                </MenuItem>
                {portfolios?.sort((a, b) => a.name.localeCompare(b.name)).map((portfolio) => (
                    <MenuItem
                        key={portfolio.name}
                        value={portfolio.name}
                    >
                        {portfolio.name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}

function getSelectControlLabelExtension(portfolios: PortfolioModel[]): string | null {
    return isAnyPortfolioAvailable(portfolios)
        ? `(${portfolios.length ?? 0} available)`
        : null;
}

function isAnyPortfolioAvailable(portfolios: PortfolioModel[]): boolean {
    return portfolios
        ? portfolios.length !== 0
        : false;
}
